export default __webpack_public_path__ + "static/media/snowman.15b485d0.png";